import React from 'react';
import { useEffect, useState } from 'react'
import { DynamicColumnsModel } from '../models/DynamicColumnsModel';
import { UserDynamicColModel } from '../models/superbit-api-models';

type Props = {
    ModuleName: string;
    onChange?: Function;
    onClose?: Function;
};

const DynamicColumns = (Props: Props) => {
    const dynamicColumnsModel: DynamicColumnsModel = new DynamicColumnsModel();
    const [moduleName, setModuleName] = useState<string>(Props.ModuleName);
    const [moduleId, setModuleId] = useState<string>("");

    const [dynamicCols, setDynamicCols] = useState<[]>([]);
    const [userDynamicCols, setUserDynamicCols] = useState<UserDynamicColModel[]>([]);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        dynamicColumnsModel.DynamicColsGetAllModules().then((res: any) => {
            res.find((module: any) => {
                if (module.name === moduleName) {
                    setModuleId(module.id);

                    dynamicColumnsModel.DynamicColsGetDynamicColsByModuleId(module.id).then((res: any) => {
                        setDynamicCols(res);
                    });

                    dynamicColumnsModel.DynamicColsGetUserDynamicColsByModuleId(module.id).then((res: any) => {
                        setUserDynamicCols(res);
                    });
                }
            });
        });
    }

    

    const showHideCol = (colId: string) => {
        const isChecked = userDynamicCols.some((userCol: any) => userCol.dynamicColId === colId);
        if (isChecked) {
            dynamicColumnsModel.DynamicColsRemoveUserDynamicCol(colId).then(() => {
                init();
                 Props.onChange && Props.onChange();
            });
        } else {
            dynamicColumnsModel.DynamicColsAddUserDynamicCol(colId).then(() => {
               init();
                Props.onChange && Props.onChange();
            });
        }
       
    }


    return (
        <div>
            <div className="ant-popover-inner-content">
                <div>
                    {dynamicCols.map((col: any) => {
                        const isChecked = userDynamicCols.some((userCol: any) => userCol.dynamicColId === col.id);
                        return (
                            <div key={col.id} className="flex-start flex-reverse" onClick={() => showHideCol(col.id)}>
                                <input
                                    type="checkbox"
                                    checked={isChecked} onClick={(e: React.MouseEvent<HTMLInputElement>) => showHideCol(col.id)}
                                />
                                <div>{col.name}</div>
                            </div>
                        );
                    })}
                </div>
                <a onClick={()=>Props.onClose && Props.onClose()}>Close</a>
            </div>
        </div>

    );
}

export default DynamicColumns;